import React__default from 'react';
import { TouchableWithoutFeedback, View, Platform } from 'react-native';

const AppColoursSelectionComponent = _ref => {
  let {
    item,
    backgroundColor,
    size = 30,
    onPress
  } = _ref;
  return /*#__PURE__*/React__default.createElement(TouchableWithoutFeedback, {
    onPress: e => {
      onPress(item, true);
    },
    style: {
      width: size,
      height: size,
      borderRadius: size,
      backgroundColor: item,
      margin: 20
    }
  }, /*#__PURE__*/React__default.createElement(View, {
    style: {
      width: size,
      height: size,
      borderRadius: size,
      backgroundColor: item,
      margin: 20,
      cursor: Platform.OS === "web" && "pointer"
    }
  }));
};
AppColoursSelectionComponent.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppColoursSelectionComponent",
  "props": {
    "size": {
      "defaultValue": {
        "value": "30",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppColoursSelectionComponent as A };
